import { render, staticRenderFns } from "./SanjivaniStudentSpecificIcardPrint.vue?vue&type=template&id=0b248070&scoped=true&"
import script from "./SanjivaniStudentSpecificIcardPrint.vue?vue&type=script&lang=js&"
export * from "./SanjivaniStudentSpecificIcardPrint.vue?vue&type=script&lang=js&"
import style0 from "./SanjivaniStudentSpecificIcardPrint.vue?vue&type=style&index=0&id=0b248070&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b248070",
  null
  
)

export default component.exports